import { FC, useMemo } from "react";
// Redux
import { useAppSelector } from "hooks/useStore";
import { getQuestionResults } from "store/result/resultSelectors";
import { selectQuiz } from "store/quiz/quizzesSelectors";
import IQuestion from "models/Question";
import QuizTypes from "types/QuizTypes";
// Components
import AnswerItem from "./AnswerItem";

type Props = {
  question: IQuestion;
  questionIndex: number;
}

const QuestionItem:FC<Props> = ({ question, questionIndex }) => {
  const quiz = useAppSelector(selectQuiz);
  const questionResults = useAppSelector((state) => getQuestionResults(state, question.ref));

  const allAnswers:number[] = [];

  const answers = useMemo(() => {
    if (!quiz) return [];
    if (quiz.type === QuizTypes.RankingPoll) {
      return quiz.questionsSettings.answersOptions || [];
    } else {
      return question.answers || [];
    }
  }, [quiz, question]);

  Object.keys(questionResults?.answers || {}).forEach((key) => {
    if (answers.find(answer => answer.ref === key)) {
      allAnswers.push(questionResults?.answers[key] || 0)
    }
  })

  const filling = 100 / Math.max(...allAnswers);
  const sum = allAnswers.reduce((a,b) => a+b, 0);

  return (
    <div className="p-4 mb-4 border border-gray-400">
      <h3 className="text-white text-sm font-bold mb-2">{`${questionIndex + 1}. ${question.title}`}</h3>
      {answers.map((answer, answerIndex) => {
        const value = questionResults?.answers[answer.ref] || 0;
        const width = value * filling;
        const percent = Number((value / sum * 100).toFixed(2)) || 0;
        const label = `${answerIndex + 1}) ${answer.title}`;
        const isCorrect = answer.correct || false;

        return <AnswerItem key={answer.ref} value={value} width={width} percent={percent} label={label} isCorrect={isCorrect} />
      })}
    </div>
  );
}
 
export default QuestionItem;